var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 636,
    height: 628,
    viewBox: "0 0 636 628",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M275.296 26.3227C293.083 -8.68908 343.096 -8.68908 360.884 26.3227L378.348 60.698C389.786 83.2128 416.714 93.0137 439.949 83.1189L475.423 68.0116C511.554 52.6247 549.866 84.7723 540.987 123.026L532.27 160.585C526.56 185.185 540.888 210.002 565.047 217.357L601.932 228.587C639.501 240.024 648.186 289.277 616.795 312.874L585.974 336.042C565.788 351.217 560.812 379.437 574.591 400.601L595.629 432.913C617.056 465.823 592.05 509.135 552.835 507.034L514.333 504.971C489.115 503.619 467.163 522.039 464.115 547.108L459.461 585.384C454.721 624.368 407.725 641.473 379.035 614.656L350.867 588.327C332.418 571.083 303.762 571.083 285.313 588.327L257.145 614.656C228.455 641.473 181.458 624.368 176.718 585.384L172.064 547.108C169.016 522.039 147.064 503.619 121.847 504.971L83.3449 507.034C44.1301 509.135 19.1237 465.823 40.551 432.913L61.5888 400.601C75.3679 379.437 70.3918 351.217 50.2054 336.042L19.385 312.874C-12.0061 289.277 -3.32146 240.024 34.2472 228.587L71.1328 217.357C95.2918 210.002 109.62 185.185 103.91 160.585L95.1923 123.026C86.3132 84.7723 124.625 52.6247 160.756 68.0117L196.231 83.1189C219.465 93.0137 246.393 83.2128 257.832 60.698L275.296 26.3227Z",
    fill: "#ECEC41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape5);
export default __webpack_public_path__ + "static/media/shape5.0c837160ff1c91cdb3216802d7b87608.svg";
export { ForwardRef as ReactComponent };